<template>
  <div style="padding: 0 5px">
    <div id="gantt-header" class="h-12 flex items-center" style="padding: 0 10px">
      <h1 class="text-xl font-bold" style="margin-right: 10px;">KERP Gantt Chart</h1>
      <button
          @click="addTask"
          class="bg-indigo-700 hover:bg-indigo-900 text-white py-2 px-4 rounded-lg flex items-center">
        <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path style="margin: 10px;" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        <span class="font-bold text-xs">
            タスクを追加する
          </span>
      </button>
      <div class="filtering-div flex">
        <div class="ml-2 flex items-center">
          <span>開始月:</span>
          <div class="ml-1 w-40">
            <Datepicker
                v-model="filterStartDateModel"
                month-picker
                placeholder="年月を選択"
                input-class-name="border border-black cursor-pointer text-center text-sm h-6"
                @change:model-value="onStartDateChange"
                cancel-text="キャンセル"
                select-text="選択"
                locale="ja"
                auto-apply
            />
          </div>
        </div>
        <div class="ml-2 flex items-center">
          <span>終了月:</span>
          <div class="ml-1 w-40">
            <Datepicker
                v-model="filterEndDateModel"
                month-picker
                placeholder="年月を選択"
                input-class-name="border border-black cursor-pointer text-center text-sm h-6"
                @change:model-value="onEndDateChange"
                cancel-text="キャンセル"
                select-text="選択"
                locale="ja"
                auto-apply
            />
          </div>
        </div>
        <div class="ml-2 flex items-center">
          <span>カテゴリ:</span>
          <select name="" id="" class="border border-black-400 ml-1 w-32 p-1" v-model="selectedCategoryId">
            <option :value="null" selected>すべて表示</option>
            <option v-for="category in categories" :key="category.id" :value="category.id">{{category.name}}</option>
          </select>
        </div>
      </div>
      <teleport to="#form">
        <div class="base" v-show="showDialog">
          <div class="overlay" v-show="showDialog" @click="showDialog=false">
          </div>
          <div class="content" v-show="showDialog">
            <h2 class="font-bold" v-if="update_mode">タスクの更新</h2>
            <h2 class="font-bold" v-else>タスクの追加</h2>
            <div class="my-4">
              <label class="text-xs">カテゴリーID:</label>
              <select v-model="form.category_id" class="text-xs border px-4 py-2 rounded-lg">
                <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}
                </option>
              </select>
              <div v-if="errors.category_id" class="text-red-500 text-xs mt-1">{{ errors.category_id }}</div>
            </div>
            <div class="my-4">
              <label class="text-xs">タスク名:</label>
              <input class="text-xs border rounded-lg px-4 py-2" v-model="form.F1">

              <div v-if="errors.F1" class="text-red-500 text-xs mt-1">{{ errors.F1 }}</div>
            </div>
            <div class="my-4">
              <label class="text-xs">担当者:</label>
              <select v-model="form.user_id" class="text-xs border px-4 py-2 rounded-lg">
                <option v-for="user in users" :key="user.id" :value="user.id">{{ user.username }}
                </option>
              </select>

              <div v-if="errors.user_id" class="text-red-500 text-xs mt-1">{{ errors.user_id }}</div>
            </div>
            <div class="my-4">
              <label class="text-xs">開始日:</label>
              <input class="text-xs border rounded-lg px-4 py-2" v-model="form.start_date" type="date">

              <div v-if="errors.start_date" class="text-red-500 text-xs mt-1">{{ errors.start_date }}</div>
            </div>

            <div class="my-4">
              <label class="text-xs">完了予定日:</label>
              <input class="text-xs border rounded-lg px-4 py-2" v-model="form.end_date" type="date">

              <div v-if="errors.end_date" class="text-red-500 text-xs mt-1">{{ errors.end_date }}</div>
            </div>

            <div class="my-4">
              <label class="text-xs">完了日:</label>
              <input class="text-xs border rounded-lg px-4 py-2" v-model="form.completion_date" type="date" :disabled="form.greenc_mst_status_type_id !== 5">

              <div v-if="errors.completion_date" class="text-red-500 text-xs mt-1">{{ errors.completion_date }}</div>
            </div>

            <div class="my-4">
              <label class="text-xs">ステータス:</label>
              <select v-model="form.greenc_mst_status_type_id" class="text-xs border px-4 py-2 rounded-lg" v-on:change="onStatusChange">
                <option v-for="item in greencMstStatusTypes" :key="item.id" :value="item.id">{{ item.name }}
                </option>
              </select>

              <div v-if="errors.greenc_mst_status_type_id" class="text-red-500 text-xs mt-1">{{ errors.greenc_mst_status_type_id }}</div>
            </div>

            <div v-if="update_mode" class="flex items-center justify-between">
              <button
                  @click="updateTask()"
                  class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-lg text-xs flex items-center">
                <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                <span class="text-xs font-bold text-white">タスクを更新</span>
              </button>
              <button @click="deleteTask(this.form.db_id)"
                      class="bg-red-500 hover:bg-red-700 text-white py-2 px-4 rounded-lg flex items-center ml-2">
                <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                <span class="text-xs font-bold text-white">タスクを削除</span>
              </button>
            </div>
            <div v-else>
              <button
                  @click="saveTask"
                  class="bg-indigo-500 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-lg flex items-center">
                <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                <span class="font-bold text-xs">
                  タスクを追加する
                </span>
              </button>
            </div>
            <div v-if="apiErrorMsg" class="text-red-500 text-xs mt-1">{{ apiErrorMsg }}</div>
          </div>
          <div v-if="loading" class="spinner-overlay">
            <div class="spinner"></div>
          </div>
        </div>
      </teleport>
    </div>
    <div>
      <p v-if="apiErrorMsgForHome" class="pb-0 mb-0 pl-5" style="color: #bf0000; font-size: 14px">{{apiErrorMsgForHome}}</p>
    </div>
    <GanttChart
        :tasks-list="filteredTasks"
        :categories="displayCategories"
        :clickable="true"
        @editTask="editTask"
        @taskUpdated="updateDraggedTask"
        :resizable="true"
        :draggable="true"
        :filter-start-date="filterStartDate"
        :filter-end-date="filterEndDate"
        :users-list="users"
        :status-types-list="greencMstStatusTypes"
        :apply-filters="true"
        :show-edit-dialog="showDialog"
    />
  </div>
</template>

<script>
import GanttChart from "@/components/GanttChartComponentOriginal.vue";
import config from "@/prm/Pbillgantts"
import apiUrl from "@/const/apiUrl";
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  components: {GanttChart, Datepicker},
  data() {
    return {
      actl: config.actl,
      aaction: config.getBillsLists,
      save: config.saveAdd,
      edit: config.edit,
      delete: config.delete,
      categories: [],
      users: [],
      tasks: [],
      greencMstStatusTypes: [],
      showDialog: false,
      form: {
        id: '',
        F1: '',
        start_date: '',
        end_date: '',
        incharge_user: '',
        percentage: 0,
        category_id: '',
        user_id: '',
        db_id: '',
        greenc_mst_status_type_id: '',
        completion_date: '',
      },
      update_mode: false,
      errors: {},
      apiErrorMsg: '',
      loading: false,
      apiErrorMsgForHome: '',
      loggedInUserId: '',
      filterStartDate: '',
      filterEndDate: '',
      filterStartDateModel: null,
      filterEndDateModel: null,
      selectedCategoryId: null,
    }
  },
  methods: {
    formatMonthYear(date) {
      if (!date || typeof date !== 'object') return '';
      if (!date.year || date.month === undefined || date.month === null) return '';

      const year = date.year;
      const month = String(date.month + 1).padStart(2, '0'); // month is 0-indexed (0-11)
      return `${year}-${month}`;
    },
    onStartDateChange(value) {
      if (value) {
        this.filterStartDate = this.formatMonthYear(value);
        if (this.filterEndDate && this.filterEndDate < this.filterStartDate) {
          this.filterEndDate = this.filterStartDate;
        }
      } else {
        this.filterStartDate = '';
      }
    },
    onEndDateChange(value) {
      if (value) {
        this.filterEndDate = this.formatMonthYear(value);
        if (this.filterStartDate && this.filterStartDate > this.filterEndDate) {
          this.filterStartDate = this.filterEndDate;
        }
      } else {
        this.filterEndDate = '';
      }
    },
    editTask(task) {
      this.apiErrorMsg = ''
      this.update_mode = true
      this.showDialog = true
      Object.assign(this.form, task)
    },
    addTask() {
      this.update_mode = false;
      this.form = {
        start_date: this.$moment().format('YYYY-MM-DD'),
        end_date: this.$moment().format('YYYY-MM-DD'),
        user_id: this.loggedInUserId,
      }
      this.showDialog = true;
      this.apiErrorMsg = ''
      this.errors = {}
    },
    formValidation() {
      this.errors = {}
      this.apiErrorMsg = ''

      if (!this.form.category_id) {
        this.errors.category_id = '入力されていない項目があります。';
      }
      if (!this.form.F1) {
        this.errors.F1 = '入力されていない項目があります。';
      }
      if (!this.form.user_id) {
        this.errors.user_id = '入力されていない項目があります。';
      }
      if (!this.form.start_date) {
        this.errors.start_date = '入力されていない項目があります。';
      }
      // if (!this.form.end_date) {
      //   this.errors.end_date = '入力されていない項目があります。';
      // }
      if (!this.form.greenc_mst_status_type_id) {
        this.errors.greenc_mst_status_type_id = '入力されていない項目があります。';
      }
      if (this.form.greenc_mst_status_type_id === 5) {
        if (!this.form.completion_date) {
          this.errors.completion_date = '入力されていない項目があります。'
        }
        if (this.form.start_date && this.form.completion_date && this.$moment(this.form.start_date).isAfter(this.form.completion_date)) {
          this.errors.start_date = '開始日は完了期限日より前の日付でなければなりません。';
          this.errors.completion_date = '完了期限日は開始日より後の日付でなければなりません。';
        }
      }else {
        if (!this.form.end_date) {
          this.errors.end_date = '入力されていない項目があります。';
        }

        if (this.form.start_date && this.form.end_date && this.$moment(this.form.start_date).isAfter(this.form.end_date)) {
          this.errors.start_date = '開始日は完了期限日より前の日付でなければなりません。';
          this.errors.end_date = '完了期限日は開始日より後の日付でなければなりません。';
        }
      }
      // if (this.form.percentage !== 0 && (!this.form.percentage || this.form.percentage < 0 || this.form.percentage > 100)) {
      //   this.errors.percentage = '進捗度は0から100の間で入力してください。';
      // }

      // Check if start_date is greater than end_date

      return Object.keys(this.errors).length > 0;
    },
    setCategories(bills) {
      let taskArr = []
      bills.map(item => {
        this.categories.push({
          id: item.id,
          name: item.name,
          collapsed: false,
          start_date: item.startdate ? this.$moment(item.startdate).format('YYYY-MM-DD') : '',
          end_date: item.enddate ? this.$moment(item.enddate).format('YYYY-MM-DD') : ''
        })
        item.greenc_tasks.map(greenc_task => {
          let id = 1
          if (taskArr.length > 0) {
            id = taskArr.length + 1
          }
          taskArr.push({
            id: id,
            category_id: greenc_task.bill_id,
            F1: greenc_task.F1,
            start_date: greenc_task.start_date ? this.$moment(greenc_task.start_date).format('YYYY-MM-DD') : '',
            end_date: greenc_task.end_date ? this.$moment(greenc_task.end_date).format('YYYY-MM-DD') : '',
            incharge_user: greenc_task.user ? greenc_task.user.username : '',
            user_id: greenc_task.user_id,
            user_name: greenc_task.user ? greenc_task.user.username : '',
            // percentage: greenc_task.progress,
            db_id: greenc_task.id,
            greenc_mst_status_type_id: greenc_task.greenc_mst_status_type_id,
            greenc_mst_status_type_name: greenc_task.greenc_mst_status_type ? greenc_task.greenc_mst_status_type.name : '',
            completion_date: greenc_task.completion_date ? this.$moment(greenc_task.completion_date).format('YYYY-MM-DD') : '',
          })
        })
      })
      this.tasks = taskArr
    },
    saveTask() {
      const formValidation = this.formValidation()
      console.log('form validation', formValidation)
      if (formValidation) return;

      this.storeTaskInDB()

    },
    storeTaskInDB() {
      this.loading = true
      const url = apiUrl + this.actl + '/' + this.save + '.json'
      console.log('api Url', url)
      const postData = this.preparePostData(this.form)
      this.$axios.post(url, postData)
          .then(response => {
            console.log('response', response)
            if (response.status === 200 && response.data.response.status) {
              const user = this.users.find(user => user.id === response.data.response.data.user_id)
              let taskObj = {...this.form}
              taskObj.user_name = user.username
              taskObj.db_id = response.data.response.data.id
              taskObj.id = this.tasks.length + 1
              this.tasks.push(taskObj)
              this.form = {}
              this.showDialog = false
            }else {
              this.apiErrorMsg = response.data.response.msg
            }
          })
          .catch(error => {
            console.log('error', error)
            this.apiErrorMsg = error.message
            if (error.response.status === 403) {
              this.apiErrorMsg = 'ログアウト状態になっています。再度ログインをお願いします。'
            }else {
              this.apiErrorMsg = error.message
            }
          })
          .finally(() => {this.loading = false})
    },
    updateTask() {
      const formValidation = this.formValidation()
      if (formValidation) return

      this.loading = true
      const url = apiUrl + this.actl + '/' + this.edit + '/' + this.form.db_id + '.json'
      console.log('api Url', url)
      const postData = this.preparePostData(this.form)
      this.$axios.post(url, postData)
          .then(response => {
            console.log('response', response)
            if (response.status === 200 && response.data.response.status) {
              const updatedTaskIndex = this.tasks.findIndex(task => task.id === this.form.id);
              if (updatedTaskIndex !== -1) {
                const user = this.users.find(user => user.id === response.data.response.data.user_id)
                let taskObj = {...this.form}
                taskObj.incharge_user = user.username
                if (updatedTaskIndex !== -1) {
                  this.tasks[updatedTaskIndex] = taskObj
                }
                this.form = {}
                this.showDialog = false
              }else {
                this.apiErrorMsg = 'タスクが見つかりません。'
              }
            }else {
              this.apiErrorMsg = response.data.response.msg
            }
          })
          .catch(error => {
            console.log('error', error)
            if (error.response.status === 403) {
              this.apiErrorMsg = 'ログアウト状態になっています。再度ログインをお願いします。'
            }else {
              this.apiErrorMsg = error.message
            }
          })
          .finally(() => {this.loading = false})
    },
    deleteTask(db_id) {
      this.loading = true
      const url = apiUrl + this.actl + '/' + this.delete + '/' + db_id + '.json'
      console.log('api Url', url)
      if (confirm('このタスクを削除してもよろしいですか?')) {
        this.$axios.delete(url)
            .then(response => {
              if (response.status === 200 && response.data.response.status) {
                const updatedTaskIndex = this.tasks.findIndex(task => task.id === this.form.id);
                if (updatedTaskIndex !== -1) {
                  this.tasks.splice(updatedTaskIndex, 1)
                  this.form = {}
                  this.showDialog = false
                }else {
                  this.apiErrorMsg = 'タスクが見つかりません。'
                }
              }else {
                this.apiErrorMsg = response.data.response.msg
              }
            })
            .catch(error => {
              console.log('error', error)
              if (error.response.status === 403) {
                this.apiErrorMsg = 'ログアウト状態になっています。再度ログインをお願いします。'
              }else {
                this.apiErrorMsg = error.message
              }
            })
            .finally(() => {this.loading = false})
      }else {
        this.loading = false
      }
    },
    preparePostData(formData) {
      if(formData) {
        return {
          F1: formData.F1,
          start_date: formData.start_date,
          end_date: formData.end_date,
          user_id: formData.user_id,
          bill_id: formData.category_id,
          progress: formData.percentage,
          greenc_mst_status_type_id: formData.greenc_mst_status_type_id,
          completion_date: formData.completion_date
        }
      }
      return {}
    },
    updateDraggedTask(task) {
      Object.assign(this.form, task)
      this.updateTask()
    },
    onStatusChange() {
      if (this.form.greenc_mst_status_type_id === 5) {
        this.form.completion_date = this.$moment().format('YYYY-MM-DD')
      }else {
        this.form.completion_date = ''
        if (!this.form.end_date) {
          this.form.end_date = this.$moment().format('YYYY-MM-DD')
        }
      }
    }
  },
  mounted() {
    this.loading = true
    this.apiErrorMsgForHome = ''
    const url = apiUrl + this.actl + '/' + this.aaction + '.json'
    console.log('apiUrl', url)
    this.$axios.get(url)
        .then(response => {
          console.log('response', response)
          if (response.status === 200 && response.data.response.status) {
            this.users = response.data.response.users
            this.greencMstStatusTypes = response.data.response.greenc_mst_status_types
            this.loggedInUserId = response.data.response.loggedInUser ? response.data.response.loggedInUser.id : ''
            this.setCategories(response.data.response.bills)
          }else {
            this.apiErrorMsgForHome = response.data.response.msg
          }
        })
        .catch(error => {
          console.error(error)
          if (error.response.status === 403) {
            this.apiErrorMsgForHome = 'ログアウト状態になっています。再度ログインをお願いします。'
          }else {
            this.apiErrorMsgForHome = error.message
          }
        })
        .finally(() => {this.loading = false})
  },
  watch: {
    filterStartDateModel(val) {
      this.filterStartDate = this.formatMonthYear(val);
      if (!val || !("year" in val)) return;

      if (
          this.filterEndDateModel &&
          "year" in this.filterEndDateModel &&
          this.filterEndDateModel.year !== undefined &&
          this.filterEndDateModel.month !== undefined
      ) {
        const end = this.filterEndDateModel;

        // If start > end → set end = start
        if (end.year < val.year || (end.year === val.year && end.month < val.month)) {
          this.filterEndDateModel = { ...val };
        }
      }
    },
    filterEndDateModel(val) {
      this.filterEndDate = this.formatMonthYear(val);
      if (!val || !("year" in val)) return;

      if (
          this.filterStartDateModel &&
          "year" in this.filterStartDateModel &&
          this.filterStartDateModel.year !== undefined &&
          this.filterStartDateModel.month !== undefined
      ) {
        const start = this.filterStartDateModel;

        // If end < start → set start = end
        if (start.year > val.year || (start.year === val.year && start.month > val.month)) {
          this.filterStartDateModel = { ...val };
        }
      }
    }
    // 'form.greenc_mst_status_type_id': function () {
    // if (val === 5) {
    //   this.form.end_date = ''
    //   this.form.completion_date = this.$moment().format('YYYY-MM-DD')
    // } else {
    //   this.form.completion_date = ''
    //   this.form.end_date = this.$moment().format('YYYY-MM-DD')
    // }
    // }
  },
  computed: {
    filteredTasks() {
      if (this.selectedCategoryId) {
        return this.tasks.filter((task) => task.category_id === this.selectedCategoryId);
      }

      return this.tasks
    },
    displayCategories() {
      if (this.selectedCategoryId) {
        return this.categories.filter((category) => category.id === this.selectedCategoryId);
      }
      return this.categories
    }
  }
}
</script>

<style>
.base {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: gray;
  opacity: 0.5;
}

.content {
  background-color: white;
  position: relative;
  border-radius: 10px;
  padding: 40px;
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent overlay */
  z-index: 9999; /* Ensure the spinner overlay appears above other content */
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite; /* Spin animation */
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>